import type { FoodProfile } from '@/types/foodProfile'
import type { BaseSliceState } from '../../types'

export interface FoodProfilesState extends BaseSliceState {
  foodProfiles: FoodProfile[]
}

export enum FoodProfilesActionTypes {
  SET_FOOD_PROFILES = 'foodProfiles/set',
  SET_ERROR = 'foodProfiles/error',
  CLEAR = 'foodProfiles/clear'
}

export type FoodProfilesAction =
  | { type: FoodProfilesActionTypes.SET_FOOD_PROFILES; payload: FoodProfile[] }
  | { type: FoodProfilesActionTypes.SET_ERROR; payload: string }
  | { type: FoodProfilesActionTypes.CLEAR }
